import { scoreTypes } from '@/constants';
import { mediaQueriesMixin } from './mediaQueries';

export const scoreMixin = {
    mixins: [mediaQueriesMixin],
    methods: {
        getScore(partner, scoreType, index, shouldCorrectDecimalPlace) {
            return scoreType === scoreTypes.number
                ? this.getDecimalScore(partner.score, shouldCorrectDecimalPlace)
                : this.getTextScore(index);
        },
        getTextScore(index) {
            const rating =
                index === 0 ? 'Excellent' : index <= 2 ? 'Great' : 'Good';
            return this.$t(rating);
        },
        getDecimalScore(score, shouldAddDecimalPlace) {
            if (shouldAddDecimalPlace && score.toString().length < 2) {
                return score + '.0';
            }
            return score;
        },
        getScoreTextSize() {
            return this.isMobile()
                ? this.partnerScoreTextSizeMobile
                : this.partnerScoreTextSizeDesktop;
        },
    },
};
